import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './tokens.scss'
import './styles.css'
import './theme.scss'
import { initializeTheme } from './theme'
import App from './App.tsx'

initializeTheme()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
